module.exports = __webpack_public_path__ + "static/badge-477c20b5000ab7fe9ccf5e650e647e2e.svg";